// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2hhDG","total":"Header_total__3LiDE","blue":"Header_blue__2feWJ","green":"Header_green__1QQy-","red":"Header_red__35wTK"};